export default class SensorDto {
    constructor(obj) {
        this.id = obj.id
        this.code = obj.id
        this.sensorType = obj.sensorType
        this.materielType = obj.sensorType
        this.range = obj.range
        this.providerId = obj.providerId
        this.manufacturerId = obj.manufacturerId
        this.cellNumber = obj.cellNumber
        this.length = obj.length
        this.height = obj.height
        this.purchaseDate = obj.purchaseDate
        this.withdrawalDate = obj.withdrawalDate
        this.manufactureDate = obj.manufactureDate
        this.warrantyTime = obj.warrantyTime
        this.comment = obj.comment
        this.state = obj.state
        this.reference = obj.reference
        this.serialNumber = obj.serialNumber
        this.department = obj.department
        this.city = obj.city
        this.stationCode = obj.stationCode
        this.updateLogin = obj.updateLogin
        this.updateDate = obj.updateDate
        this.administrator = obj.administrator
        this.desiccant = obj.desiccant
        this.powerSupplyType = obj.powerSupplyType
        this.pileNumber = obj.pileNumber
        this.networkCode = obj.networkCode
        this.referentLogin = obj.referentLogin
        this.replacementDate = obj.replacementDate
        this.supplyTime = obj.supplyTime
        this.jobExecutionId = obj.jobExecutionId
        this.isEquipment = obj.isEquipment
    }
}